<template>
  <b-modal size="md" v-model="show" centered title="Leistungsgruppe wählen"
  >
    <b-row>
      <b-col style="height: 55vh; overflow: auto">
        <b-table thead-class="display_none" striped hover selectable :items="legrs" :fields="legr_fields"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelectedGroup"
                 ref="group_table"
        >

        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSelected">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

export default {
  name: "SelectLegrDialog",
  data() {
    return {
      show: false,
      loader: undefined,
      legrs: [],
      legr_fields: [{key: "name", label: 'Gruppe wählen'}],
      selected: [],
      allowEmpty: false,
    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0 || this.allowEmpty;
    }
  },
  methods: {
    onSelected() {
      this.show = false;
      this.$emit("legr-selected", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog(legrs, allowEmpty = false) {
      this.allowEmpty = allowEmpty;
      if (legrs && legrs.length) {
        legrs.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        this.legrs = legrs;
      }
      this.selected = [];
      this.show = true;
      if (this.legrs.length === 0) {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/create/legrs'
        ).then(this.responseOkGet, this.responseError)
      }
    },
    rowSelectedGroup(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },

    getReturnData: function () {
      return {
        selected_legr: this.selected.length ? this.selected[0] : null,
      };
    },
    showLoader() {
      //this.loader = this.$loading.show();
    },
    hideLoader() {
      /*if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }*/
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200 && response.body.status === "ok") {
        response.body.data.legrs.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        this.legrs = response.body.data.legrs;
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
